'use client'

import UIFlex from '@components/ui/UIFlex'
import UIText from '@components/ui/UIText'
import { SxProps } from '@mui/joy/styles/types'
import { useIsAppControl } from '@store/isApp'
import color from '@ui/style/color.theme'
import pxToRem from '@utils/pxToRem'

interface AsideAdWrapperProps {
	sx?: SxProps
	children: React.ReactNode
}

const AsideAdWrapper = ({ sx, children }: AsideAdWrapperProps) => {
	const { isApp } = useIsAppControl()
	return (
		!isApp && (
			<UIFlex
				alignItems="center"
				bgcolor="#f8f8f8"
				padding={{
					xs: `${pxToRem(10)} 0 ${pxToRem(20)}`,
					xl: `${pxToRem(10)} 0 ${pxToRem(30)}`,
				}}
				sx={sx}
			>
				<UIText
					sx={{
						textAlign: 'center',
						fontSize: pxToRem(11),
						lineHeight: pxToRem(18),
						color: color.colGray5,
						fontWeight: 500,
						marginBottom: pxToRem(10),
					}}
				>
					ADVERTISEMENT
				</UIText>
				<UIFlex
					alignItems="center"
					sx={{
						'&>*:not(:first-child)': {
							marginTop: pxToRem(10),
						},
					}}
				>
					{children}
				</UIFlex>
			</UIFlex>
		)
	)
}

export default AsideAdWrapper
